module.exports = __webpack_public_path__ + "img/icons8-css3.d10f4bf6.svg";